/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-23T10:16:01-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-17T15:11:37-07:00
*/



import React from 'react'
import { css } from 'aphrodite/no-important';
import style from './style';
import Avatar from '../../../common/Avatar';
import { Link } from 'react-router';

const MsgItem = (props) => {
  let msgContents

  if(props.tripData) {
    // this is a trip message.
    let trip = props.tripData;
    msgContents = <Link to={`/trip/${trip.id}`}>Request to join trip: {trip.city}, {trip.region}, {trip.country}</Link>;

  } else {
    // this is a standard message.
    msgContents = props.msgText;
  }

  //console.log('msgItem:', props);
  return(
    <div className={css(style.msg)}>
      <div className={css(style.msgContainer, props.isSent && style.isSent)}>
        <div className={css(style.msgAvatar, props.isSent ? style.msgAvatar_isSent : style.msgAvatar_isReceived, props.isContinous && style.continued)}>
          {/* <Link to={`/~${}`}> */}
            <Avatar src={props.avatar} />
          {/* </Link> */}
        </div>
        <div className={css(style.msgMessage, style.caret, props.isSent ? style.caret_right : style.caret_left)}>
          <p className={css(style.msgText)}>
            {msgContents}
          </p>
        </div>
      </div>
      <div className={css(style.msgFooter, props.isSent ? style.msgFooter_isSent : style.msgFooter_isReceived)}>{props.timeStamp}</div>
    </div>
  )};

MsgItem.propTypes = {
  userProfile: React.PropTypes.object,
  isSent: React.PropTypes.bool,
  msgText: React.PropTypes.string.isRequired,
  timeStamp: React.PropTypes.string.isRequired
};



export default MsgItem;



// WEBPACK FOOTER //
// ./src/components/pages/Mail/MsgItem/index.jsx